import axiosApi from "./axios_config";

export async function get(url: string, config = {}) {
  return await axiosApi.get(url, { ...config }).then((response) => response.data);
}
export async function post(url: string, data?: any, config = {}) {
  return axiosApi.post(url, data, { ...config }).then((response) => response.data);
}

export async function patch(url: string, data?: any, config = {}) {
  return axiosApi.patch(url, { ...data }, { ...config }).then((response) => response.data);
}

export async function del(url: string, config = {}) {
  return await axiosApi.delete(url, { ...config }).then((response) => response.data);
}

export async function getPictures(url: string, config = {}) {
  return await axiosApi.get(url, { ...config, responseType: "blob" });
}
